module.exports = __webpack_public_path__ + "assets/img/theX-content-4.0060c8c2.png";